export const buildOptionsArrayGivenMinAndMaxValues = ({
  minValue = 0,
  maxValue = 1,
} = {}) =>
  [...Array(maxValue - minValue + 1).keys()].map((elementInArray) => {
    const value = elementInArray + minValue;
    return { label: `${value}`, value: `${value}` };
  });
